// SidebarBucketsModals.jsx

import React from 'react';

// Components
import ConversationCreateModal from 'channels/components/ConversationCreateModal';
import AddDatabaseModal from 'components/adddatabasemodal/AddDatabaseModal';
import ChannelModal from 'main/sidebar/channels/ChannelModal';
import DashboardModal from 'main/sidebar/dashboards/DashboardModal';

/**
 * SidebarBucketsModals
 *
 * Renders the modal stack used by the sidebar buckets section.
 *
 * @param {object} modalState - Modal state values and setters for the sidebar buckets flow.
 * @param {function} [onCreated] - Called after a nested create completes successfully (closes parent AddModal).
 *
 * @returns {ReactNode} The rendered modal stack.
 */
const SidebarBucketsModals = ({ modalState, onCreated }) => {

    // ----- RENDER ----- //

    return (
        <>
            <DashboardModal
              isOpen={modalState.dashboardModalOpen}
              onClose={() => modalState.setDashboardModalOpen(false)}
              onCreated={onCreated}
            />

            <ChannelModal
              isOpen={modalState.channelModalOpen}
              onClose={() => modalState.setChannelModalOpen(false)}
              onCreated={onCreated}
            />

            <ConversationCreateModal
              isOpen={modalState.conversationModalOpen}
              onClose={() => modalState.setConversationModalOpen(false)}
              onCreated={onCreated}
            />

            <AddDatabaseModal
              isOpen={modalState.addDatabaseModalOpen}
              baseKey={modalState.activeBaseKey}
              onClose={() => modalState.setAddDatabaseModalOpen(false)}
              onCreated={onCreated}
            />
        </>
    );
};

// Dev Tools
SidebarBucketsModals.displayName = 'SidebarBucketsModals';

export default SidebarBucketsModals;
